/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0)
    return 1;
if (i === Math.floor(i) && (i >= 2 && i <= 4) && v === 0)
    return 3;
if (!(v === 0))
    return 4;
return 5;
}

export default ["cs",[["dop.","odp."]],u,[["N","P","Ã","S","Ä","P","S"],["ne","po","Ãºt","st","Ät","pÃ¡","so"],["nedÄle","pondÄlÃ­","ÃºterÃ½","stÅeda","Ätvrtek","pÃ¡tek","sobota"],["ne","po","Ãºt","st","Ät","pÃ¡","so"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["led","Ãºno","bÅe","dub","kvÄ","Ävn","Ävc","srp","zÃ¡Å","ÅÃ­j","lis","pro"],["ledna","Ãºnora","bÅezna","dubna","kvÄtna","Äervna","Äervence","srpna","zÃ¡ÅÃ­","ÅÃ­jna","listopadu","prosince"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["led","Ãºno","bÅe","dub","kvÄ","Ävn","Ävc","srp","zÃ¡Å","ÅÃ­j","lis","pro"],["leden","Ãºnor","bÅezen","duben","kvÄten","Äerven","Äervenec","srpen","zÃ¡ÅÃ­","ÅÃ­jen","listopad","prosinec"]],[["pÅ.n.l.","n.l."],["pÅ. n. l.","n. l."],["pÅed naÅ¡Ã­m letopoÄtem","naÅ¡eho letopoÄtu"]],1,[6,0],["dd.MM.yy","d. M. y","d. MMMM y","EEEE d. MMMM y"],["H:mm","H:mm:ss","H:mm:ss z","H:mm:ss, zzzz"],["{1} {0}",u,u,u],[",","Â ",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0Â %","#,##0.00Â Â¤","#E0"],"CZK","KÄ","ÄeskÃ¡ koruna",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"CSK":["KÄs"],"CZK":["KÄ"],"ILS":[u,"âª"],"INR":[u,"â¹"],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"RON":[u,"L"],"RUR":[u,"Ñ."],"TWD":["NT$"],"USD":["US$","$"],"VND":[u,"â«"],"XEU":["ECU"],"XXX":[]},"ltr", plural];
